import React, { useEffect } from 'react';
import PageTitle from '../components/common/PageTitle';

const AdvertisePage: React.FC = () => {
  useEffect(() => {
    document.title = 'Advertise on Legal Nest';
  }, []);

  // Sample ad placement options
  const adPlacements = [
    {
      name: 'Premium Leaderboard',
      description: 'Top of page, high-visibility placement across all pages',
      size: '728×90',
      device: 'Desktop & Tablet',
      cpm: '₹450'
    },
    {
      name: 'Article In-feed',
      description: 'Native placement within article content',
      size: '336×280',
      device: 'All devices',
      cpm: '₹380'
    },
    {
      name: 'Sidebar Rectangle',
      description: 'Persistent sidebar placement with high engagement',
      size: '336×280',
      device: 'Desktop',
      cpm: '₹350'
    },
    {
      name: 'Mobile Banner',
      description: 'Mobile-optimized banner for maximum visibility',
      size: '320×100',
      device: 'Mobile only',
      cpm: '₹320'
    }
  ];

  const audienceMetrics = [
    { label: 'Monthly Page Views', value: '1.2M+' },
    { label: 'Unique Visitors', value: '450K+' },
    { label: 'Avg. Time on Page', value: '4m 30s' },
    { label: 'Legal Professionals', value: '65%' },
    { label: 'Law Students', value: '20%' },
    { label: 'Corporate Decision Makers', value: '15%' }
  ];

  return (
    <div className="container-custom py-10">
      <PageTitle title="Advertise on Legal Nest" />

      <div className="max-w-4xl mx-auto">
        <p className="text-lg text-center text-neutral-600 mb-12">
          Reach India's largest audience of legal professionals, law students, and corporate decision makers.
        </p>

        <div className="bg-white p-8 rounded-xl shadow-md mb-12">
          <h2 className="text-2xl font-serif font-bold mb-6">Our Audience</h2>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mb-8">
            {audienceMetrics.map((metric, index) => (
              <div key={index} className="text-center p-4 bg-neutral-50 rounded-lg">
                <p className="text-3xl font-bold text-primary-600 mb-2">{metric.value}</p>
                <p className="text-sm text-neutral-600">{metric.label}</p>
              </div>
            ))}
          </div>
          
          <p className="text-neutral-600">
            Legal Nest attracts a highly targeted audience of legal professionals, including practicing lawyers, judges, 
            law students, corporate legal departments, and legal academia.
          </p>
        </div>

        <h2 className="text-2xl font-serif font-bold mb-6">Advertising Options</h2>
        
        <div className="overflow-x-auto mb-12">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-neutral-100">
                <th className="p-4 text-left border-b">Placement</th>
                <th className="p-4 text-left border-b">Description</th>
                <th className="p-4 text-left border-b">Size</th>
                <th className="p-4 text-left border-b">Device</th>
                <th className="p-4 text-left border-b">CPM Rate</th>
              </tr>
            </thead>
            <tbody>
              {adPlacements.map((placement, index) => (
                <tr key={index} className="border-b hover:bg-neutral-50">
                  <td className="p-4 font-medium">{placement.name}</td>
                  <td className="p-4 text-neutral-600">{placement.description}</td>
                  <td className="p-4">{placement.size}</td>
                  <td className="p-4">{placement.device}</td>
                  <td className="p-4">{placement.cpm}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="bg-primary-50 p-8 rounded-xl border border-primary-100 mb-12">
          <h2 className="text-2xl font-serif font-bold mb-4">Custom Solutions</h2>
          <p className="mb-4">
            Beyond standard ad placements, we offer custom advertising solutions including:
          </p>
          <ul className="space-y-2 mb-6">
            <li className="flex items-start">
              <span className="text-primary-500 mr-2">✓</span>
              <span>Sponsored content and advertorials</span>
            </li>
            <li className="flex items-start">
              <span className="text-primary-500 mr-2">✓</span>
              <span>Newsletter sponsorships</span>
            </li>
            <li className="flex items-start">
              <span className="text-primary-500 mr-2">✓</span>
              <span>Webinar and event sponsorships</span>
            </li>
            <li className="flex items-start">
              <span className="text-primary-500 mr-2">✓</span>
              <span>Custom email campaigns</span>
            </li>
          </ul>
        </div>

        <div className="text-center">
          <h2 className="text-2xl font-serif font-bold mb-6">Contact Us</h2>
          <p className="mb-6 text-neutral-600">
            Interested in advertising on Legal Nest? Contact our advertising team for a custom proposal.
          </p>
          <a 
            href="mailto:advertising@legalnest.live" 
            className="btn btn-primary inline-block"
          >
            Email Advertising Team
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdvertisePage;